import { useState } from 'react';
import axios from '../../../interceptors/interceptors';
import appInsightsService from '../../../services/appInsightsService';
import { useGlobalContext } from '../../../context/global-context-provider'; 

export const useDownloadPDF = (message, additionalPayload = {}) => {
  const { cdoName: globalCdoName } = useGlobalContext();
  const [isDownloading, setIsDownloading] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);

  const surveyId = message?.infContextDetails?.surveyId || '';

  const downloadFile = (blob, filename) => {
    // Create a new blob with explicit content type to force download
    const downloadBlob = new Blob([blob], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(downloadBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  };

  const handleDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);

    // Track download button click
    appInsightsService.trackEvent({
      name: 'SummaryCardDownloadClicked',
      properties: {
        current_step: "Summary_Download_Clicked",
        conversationId: message?.AsyncHBID,
        message: `Downloading Summary PDF for asyncHBID: ${message?.infContextDetails?.asyncHBId || ''}`,
        cdoName: globalCdoName || process.env.REACT_APP_CDO_NAME || '',
        surveyId: surveyId || '',
        patientID: message?.infContextDetails?.patientId || ''
      }
    });

    const requestBody = {
      surveyId: surveyId,
      ...additionalPayload
    };

    try {
      const { data } = await axios.post('/api/download-pdf', requestBody, {
        responseType: 'blob',
        withCredentials: true
      });

      const today = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric'}).replace(/\//g, '');
      const filename = `SymptomsmartAssessmentReport_${today}.pdf`;
      downloadFile(data, filename);

      console.log('Download successful');
    } catch (error) {
      console.error('Download failed:', error);
      setToastMessage({
        type: 'error',
        header: 'Download Failed',
        body: 'Unable to download the summary. Please try again.'
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    isDownloading,
    toastMessage,
    setToastMessage,
    handleDownload
  };
};
